import "../design/projecttasks.css";
import ProjectTasks from "./projecttasks";

export default class TasksByStatus extends ProjectTasks {

    constructor(props) {
        super(props);
        this.state = {
            taskByStatus: 0
        }
    }


    async getTasks() {
        let result = await this.taskService.getTasksByStatus(this.props.match.params.projectID, this.props.match.params.taskStatusID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            console.log(result);
            this.setState({
                tasks: result
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/sites/tasksByStatus.js